export * from './create.component';
export * from './create.service';


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/create/index.ts